import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

import { removeUrlParameters } from '@/helpers/common';
import {
  AUTH_MODALS_MAP,
  MODAL_QUERY_KEY,
  ModalQueryByName,
  Modals,
  NON_AUTH_MODALS_MAP,
} from '@/helpers/modals';
import { useCommonStore } from '@/store';

export const useDialogs = () => {
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const pendingUserPure = useCommonStore.use.pendingUserPure();

  const searchParams = useSearchParams();
  const modalQueryKey = searchParams.get(MODAL_QUERY_KEY);

  const modalQuery = useMemo(() => {
    if (!modalQueryKey || pendingUserPure) return;

    const modal = Object.keys(ModalQueryByName).find(
      (key) => ModalQueryByName[key as Modals] === modalQueryKey
    ) as Modals;

    if (!modal) return;

    const isNonAuthModal = modal && NON_AUTH_MODALS_MAP.includes(modal);
    const isAuthModal = modal && AUTH_MODALS_MAP.includes(modal);

    if (isAuthenticated && isNonAuthModal) {
      return removeUrlParameters([MODAL_QUERY_KEY]);
    }
    if (!isAuthenticated && isAuthModal) {
      return removeUrlParameters([MODAL_QUERY_KEY]);
    }

    return modal;
  }, [modalQueryKey, pendingUserPure, isAuthenticated]);

  return { modal: modalQuery };
};
